import React, { useState } from "react";
import Input from "../../../components/FormComponents/Input";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { toastError } from "../../../utils/toastUtils";

const defaultField = {
  name: "",
  cell_id: "",
  type: "cell",
  overwrite: true,
  total_columns: null
};

const AddExcelFieldForm = ({ onAdd }) => {
  const [inputValue, setInputValue] = useState(defaultField);

  const handleChange = (name, value) => {
    setInputValue((prev) => ({
      ...prev,
      [name]: name === "total_columns" ? parseInt(value) : value
    }));
  };

  const handleAdd = () => {
    if (!inputValue.name.trim()) {
      toastError("Name cannot be empty");
      return;
    }

    onAdd(inputValue);
    setInputValue(defaultField);
  };

  return (
    <div className="excel_template_action">
      <SingleSelectBox
        selectedData={inputValue.type}
        options={[
          { id: "cell", name: "cell" },
          { id: "recordset-list", name: "recordset-list" },
          { id: "re-calculate", name: "re-calculate" }
        ]}
        onChange={(obj) => handleChange("type", obj.id)}
      />

      <Input
        name="name"
        value={inputValue.name}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        placeholder="Enter Name"
      />

      <Input
        name="cell_id"
        value={inputValue.cell_id}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        placeholder="Enter Cell ID"
      />

      {inputValue.type === "recordset-list" && (
        <Input
          type="number"
          name="total_columns"
          value={inputValue.total_columns}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          placeholder="Total Columns"
        />
      )}

      <ButtonActionIcon type="add" onClick={handleAdd} />
    </div>
  );
};

export default AddExcelFieldForm;
